module.exports = "https://www.gc-pro.gnp.com.mx/5acef8c9a08c6f94a503203831b880f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-3.png
// module id = 951
// module chunks = 0 1